import { render, staticRenderFns } from "./AcademicProgressDiscussionHistory.vue?vue&type=template&id=05223ebe&scoped=true"
import script from "./AcademicProgressDiscussionHistory.vue?vue&type=script&lang=js"
export * from "./AcademicProgressDiscussionHistory.vue?vue&type=script&lang=js"
import style0 from "./AcademicProgressDiscussionHistory.vue?vue&type=style&index=0&id=05223ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05223ebe",
  null
  
)

export default component.exports